export default {
  date: '日期',
  chooseExpDate: '选择日期',
  filterExpDate: '按日期筛选',
  experienceType: '类型',
  filterExperienceType: '按类型筛选',
  experienceVibe: '氛围',
  filterExperienceVibe: '按氛围筛选',
  search: '搜索',
  viewCalendar: '日历',
  back: '返回',
  previous: '上一个',
  next: '下一个',
  noExperiences: '暂无体验',
  cancelChanges: '取消更改',
  saveChanges: '保存更改',
  removeFromReservation: '从预订中移除',
  addToCart: '加入购物车',
  proceedToCheckout: '前往结账',
  selectDate: '选择日期',
  startDate: '开始日期',
  endDate: '结束日期',
  submit: '提交',
  filterExperienceTypeScreenReader:
    '使用这些筛选器来缩小结果范围。选择筛选器时，内容会自动更新。',
};
